export const rating_moodys = [
  { value: "NR" },
  { value: "Aaa" },
  { value: "Aa1" },
  { value: "Aa2" },
  { value: "Aa3" },
  { value: "A1" },
  { value: "A2" },
  { value: "A3" },
  { value: "Baa1" },
  { value: "Baa2" },
  { value: "Baa3" },
  { value: "Ba1" },
  { value: "Ba2" },
  { value: "Ba3" },
  { value: "B1" },
  { value: "B2" },
  { value: "B3" },
  { value: "Caa1" },
  { value: "Caa2" },
  { value: "Caa3" },
  { value: "Ca" },
  { value: "C" },
  { value: "D" },
];
